"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACTextarea = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var antd_1 = require("antd");
var FormInputLabel_1 = __importDefault(require("./FormInputLabel"));
var TextArea = antd_1.Input.TextArea;
var ACTextarea = function (props) {
    var handleChange = function (e) {
        if (props.onChange) {
            props.onChange(e.target.value);
        }
    };
    var defaultMinRows = 2;
    var defaultMaxRows = 6;
    return ((0, jsx_runtime_1.jsxs)("div", { className: props.containerClassName, children: [(0, jsx_runtime_1.jsx)(FormInputLabel_1.default, __assign({}, props)), (0, jsx_runtime_1.jsx)(TextArea
            // style={{ height: '130px' }}
            , { 
                // style={{ height: '130px' }}
                placeholder: props.placeholder, allowClear: props.allowClear, disabled: props.disabled, id: props.name, autoFocus: props.autoFocus, autoSize: (props === null || props === void 0 ? void 0 : props.autoSize) || {
                    minRows: props.minRows ? props.minRows : defaultMinRows,
                    maxRows: props.maxRows ? props.maxRows : defaultMaxRows,
                }, className: "apx-ui_input__text ".concat(props.className, " ").concat((props === null || props === void 0 ? void 0 : props.color) || 'primary'), name: props.name, showCount: props.showCount, status: props.required && props.errorText ? 'error' : '', onChange: function (e) {
                    handleChange(e);
                }, value: props.value }), props.required ? ((0, jsx_runtime_1.jsx)("p", { className: props.errorClassName, children: props.errorText && props.errorText })) : ('')] }));
};
exports.ACTextarea = ACTextarea;
